import { appContext } from '../AppContext';
import { ESignatureTypes, FieldTypes } from '../helpers/constants';
import { getCurrentUser } from '../helpers/UserUtility';

export interface SignatureValue {
  FileId: string;
  SignedByName?: string;
  SignedByEmail?: string;
  SignedBy?: string;
  FromPublicForm?: boolean;
}

export const MODAL_CONFIGURATION = {
  updateOnly: {
    disclosure:
      'By selecting "Save", I agree that the electronic representation of my signature is my signature for all purposes when I (or my agent) use them on electronic documents, including legally binding documents. ',
    saveText: 'Save'
  },
  initials: {
    disclosure:
      'By selecting "Sign", I agree that the electronic representation of my initials are my initials for all purposes when I (or my agent) use them on these electronic documents, including legally binding documents. ',
    saveText: 'Sign'
  },
  signature: {
    disclosure:
      'By selecting "Sign", I agree that the electronic representation of my signature is my signature for all purposes when I (or my agent) use them on these electronic documents, including legally binding documents. ',
    saveText: 'Sign'
  }
};

export const SignatureAspectRatio = 3.63;
export const InitialsAspectRatio = 1.2;

export function getESignatureDimensions() {
  return getDimensions(FieldTypes.eSignature);
}

export function getESignatureInitialsDimensions() {
  return getDimensions(FieldTypes.eSignatureInitials);
}

export function getDimensions(fieldType) {
  const aspectRatio = fieldType === FieldTypes.eSignature ? SignatureAspectRatio : InitialsAspectRatio;
  const actualWidth = fieldType === FieldTypes.eSignature ? 800 : 300;
  const actualHeight = Math.round(actualWidth / aspectRatio);
  return { actualWidth, actualHeight };
}

export function HasAdoptedSignature(fieldType: number) {
  const state = appContext.store.getState();
  const fieldIds: string[] = state.formeditor.template?.fields.filter(({ type }) => type === fieldType).map((field) => field.id);
  const formValues = state.formeditor.form?.values;
  const currentUser = getCurrentUser();
  const isPublicForm = !!state.formeditor.sharedAccessToken;
  const signatureTypeProp = fieldType === FieldTypes.eSignature ? 'signature' : 'initials';

  if (isPublicForm) {
    const hasValues = formValues.filter(({ fieldId }) => fieldIds.includes(fieldId)).some(({ value }) => !!value);
    const hasSignature = !!state.formeditor.savedSignatures?.[signatureTypeProp];

    return hasValues && hasSignature;
  }

  const hasAdoptedSignature = formValues.some(
    (formValue) => formValue.value && fieldIds.includes(formValue.fieldId) && JSON.parse(formValue.value).SignedBy === currentUser.id
  );

  return hasAdoptedSignature;
}

export function GetESignatureType(fieldType) {
  return fieldType === FieldTypes.eSignature ? ESignatureTypes.signature : ESignatureTypes.initials;
}

export function GetSignature(fieldType) {
  const state = appContext.store.getState();
  const isPublicForm = !!state.formeditor.sharedAccessToken;
  const signatureTypeProp = GetESignatureType(fieldType);
  if (isPublicForm) {
    return state.formeditor.savedSignatures[signatureTypeProp] || null;
  }
  return state.profile.savedSignatures ? state.profile.savedSignatures[signatureTypeProp] : null;
}

export function GetSignatureValue(fileId: string): SignatureValue {
  const state = appContext.store.getState();
  const isPublicForm = !!state.formeditor.sharedAccessToken;
  const value: SignatureValue = { FileId: fileId };

  if (isPublicForm) {
    const recipient = state.formeditor.policyInfo.recipient;
    if (recipient) {
      value.SignedByName = recipient.name;
      value.SignedByEmail = recipient.email;
    }
    value.FromPublicForm = true;
  } else {
    value.SignedBy = getCurrentUser().id;
  }

  return value;
}

export function getInitials(name: string) {
  if (name) {
    const initialsArray = name.split(' ').map((x) => x.substring(0, 1));
    let initials = '';
    if (initialsArray.length > 0) {
      initials = initialsArray[0];
    }
    if (initialsArray.length > 2) {
      initials += initialsArray[1];
    }
    if (initialsArray.length > 1) {
      initials += initialsArray[initialsArray.length - 1];
    }
    initials = initials.toUpperCase();
    return initials;
  }
  return '';
}
